<template>
    <v-modal @opened="fetchData">
        <v-loading :data="PreOrderSubGroupTotals"></v-loading>
        <slot slot="title">{{ $t('preorder.totals_per_subgroup') }}</slot>
        <slot slot="buttonContent">
            <v-block type="icon-block" height="stretch" color="white">
                <svgicon class="u-opacity-25" name="group-people" width="36" height="36"></svgicon>
                <p>{{ $t('preorder.details_per_subgroup') }}</p>
            </v-block>
        </slot>
        <div class="c-targets o-gutter">
            <div class="c-table-wrapper">
                <table-component class="o-page-row" table-class="c-table c-table--small" :data="PreOrderSubGroupTotals.SubGroupTotals" :show-caption="false" :show-filter="false">

                    <table-column key="SubGroup" :label="$t('preorder_subgroup_totals.columns.subgroup')" :sortable="false">
                        <template slot-scope="row">
                            {{row["SubGroup"]}}
                        </template>
                    </table-column>
                    <table-column key="Amount" :label="$t('preorder.product_variant_count')" :sortable="false">
                        <template slot-scope="row">
                            {{row["Amount"]}}
                        </template>
                    </table-column>
                    <table-column key="Total" :label="$t('global.total')" :sortable="false">
                        <template slot-scope="row">
                            {{row["Total"] | currency(customerCurrencySymbol) }}
                        </template>
                    </table-column>
                    <table-column key="Share" :label="$t('preorder_subgroup_totals.columns.share')" :sortable="false">
                        <template slot-scope="row">
                            {{row["Share"] | currency(customerCurrencySymbol) }}%
                        </template>
                    </table-column>
                </table-component>
            </div>
            <div class="u-text-align-center">
                <h1 class="c-dialog__title">{{ $t('preorder.marketing_material') }}</h1>
            </div>
            <div class="c-table-wrapper">
                <table-component class="o-page-row" table-class="c-table c-table--small" :data="PreOrderSubGroupTotals.MarketingSubGroupTotals" :show-caption="false" :show-filter="false">

                    <table-column key="SubGroup" :label="$t('preorder_subgroup_totals.columns.subgroup')" :sortable="false">
                        <template slot-scope="row">
                            {{row["SubGroup"]}}
                        </template>
                    </table-column>
                    <table-column key="Amount" :label="$t('preorder.product_variant_count')" :sortable="false">
                        <template slot-scope="row">
                            {{row["Amount"]}}
                        </template>
                    </table-column>
                    <table-column key="Total" :label="$t('global.total')" :sortable="false">
                        <template slot-scope="row">
                            € {{row["Total"]}}
                        </template>
                    </table-column>
                </table-component>
            </div>            
        </div>        
    </v-modal>
</template>

<script>
    import VModal from '@/components/modal/Modal'
    import VBlock from '@/components/blocks/Block'
    import VLoading from '@/components/Loading'

    // Store
    import {mapGetters} from 'vuex'

    export default {
        components: {
            VModal,
            VBlock,
            VLoading
        },
        props: {
        },
        computed: {
            ...mapGetters({
                PreOrderSubGroupTotals: 'PreOrderSubGroupTotals'
            }),
            customerCurrencySymbol() { 
                return this.$store.getters.userInfo.customerCurrencySymbol;
            }
        },
        methods: {
            fetchData() {
                this.$store.dispatch('getPreOrderSubGroupTotals', this.$route.params.id);              
            }
        }
    }
</script>

<style lang="scss" scoped>

    @import "~@/assets/scss/private";

</style>


// WEBPACK FOOTER //
// src/components/modal/common/SubGroupTotals.vue